import { AlertBanner, Button } from '@curri/components'

import { useCopyToClipboard } from '../../useCopyToClipboard.ts'

// The one moment a signing secret is readable. Curri stores it encrypted and
// no read ever returns it, so this render is the partner's single chance to
// take it — which is why the panel says so and holds the value until they
// dismiss it rather than folding on the next refetch.
//
// The secret lives in the caller's state and in this component's props and
// nowhere else: not in a ref that outlives the reveal, not in a log line.

export const SecretReveal = ({
  secret,
  onDone,
}: {
  secret: string
  onDone: () => void
}) => {
  const { copied, copy } = useCopyToClipboard()

  return (
    <AlertBanner title="Your signing secret — shown once" type="warning">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <code
          style={{
            fontFamily: 'var(--curri-font-mono)',
            fontSize: 13,
            color: 'var(--curri-text)',
            overflowWrap: 'anywhere',
          }}
        >
          {secret}
        </code>
        <span style={{ fontSize: 12.5, color: 'var(--curri-text-secondary)' }}>
          Curri stores it encrypted and never shows it again. Store it now;
          rotate to get a new one.
        </span>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            label={copied ? 'Copied' : 'Copy'}
            onClick={() => copy(secret)}
            size="small"
            type="button"
            variant="secondary"
          />
          <Button
            label="Done"
            onClick={onDone}
            size="small"
            type="button"
            variant="tertiary"
          />
        </div>
      </div>
    </AlertBanner>
  )
}
